//import { Notification } from "element-ui";
import { api } from "../../gateways/unilabApi";

export default {
  newFluid(fluidType) {
    return new Promise((resolve, reject) => {
      api
        .post("fluidMgt/newFluid/" + fluidType)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            // title: "Error",
            // message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  getFluid(fluidType, idFluid) {
    return new Promise((resolve, reject) => {
      api
        .get("fluidMgt/getById/" + fluidType + "/" + idFluid)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            // title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  updateFluid(Fluid) {
    return new Promise((resolve, reject) => {
      api
        .put("fluidMgt/updateFluid", Fluid)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  },
  deleteFluid(fluidType, idFluid) {
    return new Promise((resolve, reject) => {
      api
        .get("fluidMgt/removeById/" + fluidType + "/" + idFluid)
        .then(response => {
          if (!response.isAxiosError) {
            resolve(response.data);
          } else {
            console.log(response.response);
            //Notification.warning({
            //  title: "Error",
            //  message: response.response !== undefined ? response.response.data : "No Response"
            //});
            reject(response);
          }
        })
        .catch(error => {
          console.log(error);
          //Notification.warning({
          //  title: "Error",
          //  message: error
          //});
          reject(error);
        });
    });
  }
};
